module.exports = __webpack_public_path__ + "img/2.47b4f2c5.jpg";